/** @module Camunda/TaskDefinitionEditController */
define([
	"dojo/_base/declare",
	"mobx",
	"underscore",
	"csi/action/EditController",
	"csi/comm",
	"csi/state",
	"csi/state/rootStore",
	"csi/view",
	"csi/xml"
], function(declare, {runInAction}, _, EditController, comm, state, {rightPaneStore}, csiView, xml) {

	/**
	 * Change store editing state
	 * @param {View} defView
	 */
	function updateState(defView) {
		runInAction(() => {
			const component = rightPaneStore.adHocComponent;
			if (component) {
				component.editViewDef = defView;
			}
		});
	}

	return declare(EditController, {
		/**
		 * @override
		 * Need to override this as property view (this.widget) is destroyed when replaced in the focused pane by the form
		 */
		isValidAction: function(bEnd) {
			return true;
		},

		/**
		 * @override
		 * Open edit form in focused view pane
		 */
		openDialog: function(av) {
			this.suspendProcess();
			updateState(av.m_defView);
		},

		/**
		 * @override
		 * Write operations to save selections from form
		 */
		toWriter: function() {
			// Remove old Task Action Settings
			const formView = csiView.getView("__Form__");
			var node = this.getNode();
			this.m_writer.deleteList(_.values(node.ActionSettings));

			// Get new value for field "Info" aka "Description"
			var localeName = state.get("siteLocale");

			var info = {};
			var newValue = this.m_formData.getFieldValue("Info", true);
			info[localeName] = newValue;

			// Save new Task Action Settings
			const actionGroupWidget = this.m_formData.getField("ActionGroup").m_control;
			const actionSettings = actionGroupWidget.actionSettings;
			const settingsMap = {};

			_.each(actionSettings, function(setting, name) {
				const newNode = comm.createUrl();

				this.m_writer.createNode(newNode, "CamundaTaskDefinitionActionSettings")
					.changeAttribute("CommentsRequired", xml.ATTR_BOOLEAN, setting.CommentsRequired)
					.changeAttribute("ValidationGroup", xml.ATTR_STRING, setting.ValidationGroup);

				settingsMap[name] = newNode;
			}, this);

			this.m_writer.changeNode(this.m_urlNode)
				.changeAttributeKeys("ActionSettings", xml.ATTR_REFMAP, settingsMap, true)
				.changeAttributeKeys("Info", xml.ATTR_STRINGMAP, info, true);

			this.m_writer.changeNode(this.m_urlNode)
				.changeAttribute("ViewDefinitionPath", xml.ATTR_STRING, formView.getViewDefinitionPath())

			this.inherited(arguments);
		},

		/**
		 * @override
		 * See postProcessSuccess 
		 */
		postProcessCancel: function() {
			this.postProcessSuccess();
		},

		/**
		 * @override
		 * Switch back to task properties view
		 */
		postProcessSuccess: function() {
			updateState(null);
		}
	});
});